import { forwardRef, useEffect, useState } from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@helpers/utils';

const Slider = forwardRef(
    (
        {
            className,
            defaultValue = [0],
            valueClassName,
            onChange,
            value: propValue,
            hasRange = false,
            labelFormatter = (value) => value,
            showToolTip = false,
            ...props
        },
        ref
    ) => {
        const [value, setValue] = useState(propValue || defaultValue);
        useEffect(() => {
            setValue(propValue || defaultValue);
        }, [propValue]);
        return (
            <div className="flex flex-col justify-center h-6">
                <SliderPrimitive.Root
                    ref={ref}
                    className={cn(
                        'relative flex w-full touch-none select-none items-center',
                        className
                    )}
                    value={value}
                    onValueChange={(val) => {
                        setValue(val);
                        onChange?.(val);
                    }}
                    {...props}
                >
                    <SliderPrimitive.Track className="relative w-full h-1.5 overflow-hidden bg-gray-300 rounded-full grow">
                        <SliderPrimitive.Range className="absolute h-full bg-slider-gradient" />
                    </SliderPrimitive.Track>
                    <SliderPrimitive.Thumb className="block w-6 h-6 transition-colors border border-gray-300 rounded-full shadow bg-basicWhite focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50">
                        {showToolTip ? (
                            <div
                                className={cn(
                                    'absolute transform flex items-center -left-full -translate-x-1/2 transition-all',
                                    valueClassName
                                )}
                            >
                                <span className="ml-1 whitespace-nowrap">
                                    {' ' + ` ${labelFormatter(value)} `}
                                </span>
                            </div>
                        ) : null}
                    </SliderPrimitive.Thumb>
                </SliderPrimitive.Root>
            </div>
        );
    }
);
Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };
